import { Trophy, Medal } from "lucide-react";
import { normalizeRound, voteScores } from "@/lib/format";

function buildRanking(votes) {
  const map = {};
  votes.forEach((v) => {
    Object.entries(voteScores(v)).forEach(([name, pts]) => {
      if (!map[name]) map[name] = { total: 0, count: 0, rounds: new Set() };
      map[name].total += pts;
      map[name].count += 1;
      if (v.ronda) map[name].rounds.add(normalizeRound(v.ronda));
    });
  });
  return Object.entries(map)
    .map(([name, s]) => ({
      name,
      total: s.total,
      count: s.count,
      rounds: Array.from(s.rounds),
    }))
    .sort((a, b) => b.total - a.total);
}

export default function Ranking({ votes = [], event }) {
  const ranking = buildRanking(votes);

  return (
    <div
      data-testid="ranking-widget"
      className="border border-[#1E293B] bg-[#0F172A]"
    >
      <div className="flex items-center justify-between border-b border-[#1E293B] px-6 py-4">
        <div className="flex items-center gap-3">
          <Trophy className="h-5 w-5 text-[#FF5500]" />
          <h3 className="font-display text-2xl tracking-wider text-white">
            Ranking global
          </h3>
        </div>
        {event?.winner && (
          <span className="font-ui text-[10px] font-bold uppercase tracking-[0.2em] text-[#FF5500]">
            Campeón: {event.winner}
          </span>
        )}
      </div>

      {ranking.length === 0 ? (
        <div className="p-6">
          <p className="font-ui text-xs uppercase tracking-[0.25em] text-[#94A3B8]">
            El ranking se actualizará cuando lleguen los votos
          </p>
        </div>
      ) : (
        <ul className="divide-y divide-[#1E293B]">
          {ranking.slice(0, 10).map((r, idx) => (
            <li
              key={r.name}
              data-testid={`ranking-row-${idx}`}
              className="flex items-center justify-between gap-4 px-6 py-4 hover:bg-[#080D1A]"
            >
              <div className="flex items-center gap-4">
                <span
                  className={`flex h-9 w-9 items-center justify-center font-display text-xl tracking-wider ${
                    idx === 0
                      ? "bg-[#FF5500] text-white"
                      : idx < 3
                      ? "border border-[#FF5500] text-[#FF5500]"
                      : "border border-[#1E293B] text-[#94A3B8]"
                  }`}
                >
                  {idx + 1}
                </span>
                <div className="flex flex-col">
                  <span className="font-body text-sm font-semibold text-white">
                    {r.name}
                  </span>
                  <span className="font-ui text-[10px] font-bold uppercase tracking-[0.2em] text-[#94A3B8]">
                    {r.count} voto{r.count === 1 ? "" : "s"}
                    {r.rounds.length > 0 && ` · ${r.rounds.join(", ")}`}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-2">
                {idx === 0 && <Medal className="h-4 w-4 text-[#FF5500]" />}
                <span className="font-display text-2xl tracking-wider text-white">
                  {r.total.toFixed(1)}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
